// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from "react";

const REMINDERS = [
  { id:1, contact:"Jennifer Park", company:"BC Insurance Group", scheduledDate:"2026-02-08", scheduledTime:"9:00 AM", purpose:"Follow up on demo scheduling for Feb 14", assignedTo:"Lucas Mason", priority:"High", recurring:false, status:"upcoming" },
  { id:2, contact:"Chris Brown", company:"Canstorr Commodities", scheduledDate:"2026-02-08", scheduledTime:"10:30 AM", purpose:"Callback requested - partnership agreement discussion", assignedTo:"Tyson Becker", priority:"High", recurring:false, status:"upcoming" },
  { id:3, contact:"Lisa Grant", company:"Investor Relations", scheduledDate:"2026-02-07", scheduledTime:"2:00 PM", purpose:"Q4 investor update follow-up", assignedTo:"Ryan Miskulin", priority:"Medium", recurring:false, status:"overdue" },
  { id:4, contact:"Karen Liu", company:"Metro Beauty Collective", scheduledDate:"2026-02-10", scheduledTime:"11:00 AM", purpose:"Trial account setup confirmation", assignedTo:"Lucas Mason", priority:"Medium", recurring:false, status:"upcoming" },
  { id:5, contact:"Paul Martinez", company:"Cattle Ranch Collective", scheduledDate:"2026-02-08", scheduledTime:"2:00 PM", purpose:"Fourth outreach attempt - send email if no answer", assignedTo:"Tyson Becker", priority:"Low", recurring:false, status:"upcoming" },
  { id:6, contact:"Mike Thompson", company:"Canstorr Commodities", scheduledDate:"2026-02-10", scheduledTime:"3:00 PM", purpose:"Revised proposal review discussion", assignedTo:"Lucas Mason", priority:"High", recurring:false, status:"upcoming" },
  { id:7, contact:"Team Standup Call", company:"Internal", scheduledDate:"2026-02-10", scheduledTime:"9:00 AM", purpose:"Weekly Monday standup call", assignedTo:"Ryan Miskulin", priority:"Medium", recurring:true, status:"upcoming" },
  { id:8, contact:"Robert Kim", company:"Mining Safety Board", scheduledDate:"2026-02-12", scheduledTime:"10:00 AM", purpose:"Compliance checklist review follow-up", assignedTo:"Lee Mehling", priority:"High", recurring:false, status:"upcoming" }
];

export default function CallRemindersPage() {
  const [reminders, setReminders] = useState(REMINDERS);
  const [showForm, setShowForm] = useState(false);
  const [newReminder, setNewReminder] = useState({ contact:"", company:"", scheduledDate:"", scheduledTime:"", purpose:"", assignedTo:"", priority:"Medium", recurring:false });

  const overdue = reminders.filter(r => r.status === "overdue");
  const upcoming = reminders.filter(r => r.status === "upcoming");
  const completed = reminders.filter(r => r.status === "completed");

  const completeReminder = (id) => {
    setReminders(prev => prev.map(r => r.id === id ? { ...r, status: "completed" } : r));
  };

  const snoozeReminder = (id) => {
    setReminders(prev => prev.map(r => {
      if (r.id !== id) return r;
      const d = new Date(r.scheduledDate);
      d.setDate(d.getDate() + 1);
      return { ...r, scheduledDate: d.toISOString().split("T")[0], status: "upcoming" };
    }));
  };

  const addReminder = () => {
    if (!newReminder.contact || !newReminder.scheduledDate) return;
    setReminders(prev => [...prev, { ...newReminder, id: Date.now(), status: "upcoming" }]);
    setNewReminder({ contact:"", company:"", scheduledDate:"", scheduledTime:"", purpose:"", assignedTo:"", priority:"Medium", recurring:false });
    setShowForm(false);
  };

  const priorityBadge = (p) => {
    const map = { High:"badge badge-red", Medium:"badge badge-yellow", Low:"badge badge-blue" };
    return map[p] || "badge";
  };

  const team = ["Ryan Miskulin","Jordan Lutz","Taylor Schenher","Des Bachynski","Lucas Mason","Lee Mehling","Clorice Robertson","Tyson Becker","Tyler Hodgson"];

  const renderReminder = (r) => (
    <div key={r.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 0",borderBottom:"1px solid #334155"}}>
      <div style={{flex:1}}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
          <span style={{fontSize:14,fontWeight:600,color:"#e2e8f0"}}>{r.contact}</span>
          {r.recurring && <span className="badge badge-purple">Recurring</span>}
          <span className={priorityBadge(r.priority)}>{r.priority}</span>
        </div>
        <div style={{fontSize:12,color:"#94a3b8"}}>{r.company}</div>
        <div style={{fontSize:12,color:"#64748b",marginTop:2}}>{r.purpose}</div>
        <div style={{fontSize:11,color:"#64748b",marginTop:4,display:"flex",gap:12}}>
          <span>{r.scheduledDate} at {r.scheduledTime}</span>
          <span>Assigned: {r.assignedTo}</span>
        </div>
      </div>
      {r.status !== "completed" && (
        <div style={{display:"flex",gap:6}}>
          <button className="btn btn-sm btn-primary" onClick={() => completeReminder(r.id)}>Done</button>
          <button className="btn btn-sm btn-outline" onClick={() => snoozeReminder(r.id)}>Snooze</button>
        </div>
      )}
      {r.status === "completed" && <span className="badge badge-green">Completed</span>}
    </div>
  );

  return (
    <div>
      <div className="page-header">
        <div><h1 className="page-title">Call Reminders</h1><p>Scheduled call reminders and follow-ups</p></div>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>+ New Reminder</button>
      </div>

      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Overdue</div><div className="stat-value" style={{color:"#ef4444"}}>{overdue.length}</div></div>
        <div className="stat-card"><div className="stat-label">Upcoming</div><div className="stat-value" style={{color:"#3b82f6"}}>{upcoming.length}</div></div>
        <div className="stat-card"><div className="stat-label">Completed</div><div className="stat-value" style={{color:"#10b981"}}>{completed.length}</div></div>
        <div className="stat-card"><div className="stat-label">Recurring</div><div className="stat-value">{reminders.filter(r=>r.recurring).length}</div></div>
      </div>

      {showForm && (
        <div className="card" style={{marginBottom:16}}>
          <div className="card-header"><h3>Create Reminder</h3></div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <div><label style={{fontSize:12,color:"#94a3b8",display:"block",marginBottom:4}}>Contact</label><input className="input" value={newReminder.contact} onChange={e => setNewReminder({...newReminder, contact:e.target.value})} placeholder="Contact name" /></div>
            <div><label style={{fontSize:12,color:"#94a3b8",display:"block",marginBottom:4}}>Company</label><input className="input" value={newReminder.company} onChange={e => setNewReminder({...newReminder, company:e.target.value})} placeholder="Company" /></div>
            <div><label style={{fontSize:12,color:"#94a3b8",display:"block",marginBottom:4}}>Date</label><input className="input" type="date" value={newReminder.scheduledDate} onChange={e => setNewReminder({...newReminder, scheduledDate:e.target.value})} /></div>
            <div><label style={{fontSize:12,color:"#94a3b8",display:"block",marginBottom:4}}>Time</label><input className="input" value={newReminder.scheduledTime} onChange={e => setNewReminder({...newReminder, scheduledTime:e.target.value})} placeholder="e.g. 10:00 AM" /></div>
            <div style={{gridColumn:"1/-1"}}><label style={{fontSize:12,color:"#94a3b8",display:"block",marginBottom:4}}>Purpose</label><input className="input" value={newReminder.purpose} onChange={e => setNewReminder({...newReminder, purpose:e.target.value})} placeholder="Call purpose" /></div>
            <div><label style={{fontSize:12,color:"#94a3b8",display:"block",marginBottom:4}}>Assigned To</label>
              <select className="input" value={newReminder.assignedTo} onChange={e => setNewReminder({...newReminder, assignedTo:e.target.value})}>
                <option value="">Select</option>{team.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div><label style={{fontSize:12,color:"#94a3b8",display:"block",marginBottom:4}}>Priority</label>
              <select className="input" value={newReminder.priority} onChange={e => setNewReminder({...newReminder, priority:e.target.value})}>
                <option value="High">High</option><option value="Medium">Medium</option><option value="Low">Low</option>
              </select>
            </div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:12,marginTop:12}}>
            <label style={{fontSize:12,color:"#94a3b8",display:"flex",alignItems:"center",gap:6}}>
              <input type="checkbox" checked={newReminder.recurring} onChange={e => setNewReminder({...newReminder, recurring:e.target.checked})} /> Recurring weekly
            </label>
            <div style={{flex:1}} />
            <button className="btn btn-outline" onClick={() => setShowForm(false)}>Cancel</button>
            <button className="btn btn-primary" onClick={addReminder}>Create Reminder</button>
          </div>
        </div>
      )}

      {overdue.length > 0 && (
        <div className="card" style={{borderLeft:"3px solid #ef4444"}}>
          <div className="card-header"><h3 style={{color:"#ef4444"}}>Overdue</h3><span className="badge badge-red">{overdue.length}</span></div>
          {overdue.map(renderReminder)}
        </div>
      )}

      <div className="card">
        <div className="card-header"><h3>Upcoming Reminders</h3><span style={{fontSize:12,color:"#64748b"}}>{upcoming.length} scheduled</span></div>
        {upcoming.length > 0 ? upcoming.map(renderReminder) : <p style={{color:"#64748b",textAlign:"center",padding:20}}>No upcoming reminders</p>}
      </div>

      {completed.length > 0 && (
        <div className="card">
          <div className="card-header"><h3 style={{color:"#10b981"}}>Completed</h3></div>
          {completed.map(renderReminder)}
        </div>
      )}
    </div>
  );
}
